import { NCLink, NCNode } from '../../../../src/commonTypes';
import { addForce, getCentralPoint, getDistanceBetweenPoints } from './geometryUtils';

const MAX_WEIGHT = 0.3;
const CLUSTER_DRAG_STRENGTH = 0.25;

const shiftNodeTowards = (
	node: NCNode,
	toNode: NCNode,
	linksForNode: number
): { xShift: number; yShift: number } => {
	// Get the distance between the two nodes
	const xDistance = toNode.x - node.x;
	const yDistance = toNode.y - node.y;
	
	let weight = 0.05;
	
	// If the distance is very long, the weight is reduced proportionally
	const distance = Math.sqrt(xDistance * xDistance + yDistance * yDistance);
	const MAX_DISTANCE = 750;
	if (distance < MAX_DISTANCE) {
		weight = 0.9;
	} else {
		if (linksForNode > 50) {
			weight = 0.03;
		}
	}
	
	let xWeight = weight;
	let yWeight = weight;
	

	let weightFactor = MAX_WEIGHT;

	const xShift = xDistance  / (xWeight * weightFactor) / 100;
	const yShift = yDistance  / (yWeight * weightFactor) / 100;

	return { xShift, yShift };
};


export default function (allLinks: Array<NCLink>) {
	let links: Array<NCLink> = allLinks,
		strength = 100;

	function force(alpha: number) {
		const graph = globalThis.neuroCreate.graph;
		
		// Get the cluster of nodes that are being dragged
		const draggedNodeCluster = graph?.currentDraggedNodeCluster;
		const draggedNodes = graph?.draggedNodes;
		if (draggedNodeCluster) {
			if (draggedNodes && draggedNodes.length > 1) {
				// Dragging a group. All nodes in the cluster should be moved towards the center of the group
				const center = getCentralPoint(draggedNodeCluster);
				// Create a temporary node at the center of the group
				const centerNode = {
					x: center.x,
					y: center.y,
					uid: 'groupCenter',
					created: 0,
					colour: 'blue',
				} as NCNode;
				for (const node of draggedNodeCluster) {
					if (draggedNodes.includes(node)) continue;
					const { xShift, yShift } = shiftNodeTowards(node, centerNode, draggedNodeCluster.length);
					const currentStrength = CLUSTER_DRAG_STRENGTH * alpha;
					addForce(node, {
						x: xShift * currentStrength,
						y: yShift * currentStrength,
					});
				}
			} else {
				if (!draggedNodes) return;
				const draggedNode = draggedNodeCluster![0];
				// For each link in the dragged cluster, get the source and target nodes
				for (const node of draggedNodeCluster) {
					// Move all nodes towards the dragged node
					if (node.uid === draggedNode.uid) continue;
					// Check if the node is at least 500 units away
					const distance = getDistanceBetweenPoints(node, draggedNode);
					if (distance < 500) continue;
					const { xShift, yShift } = shiftNodeTowards(node, draggedNode, draggedNodeCluster.length);
					const currentStrength = CLUSTER_DRAG_STRENGTH * alpha;
					addForce(node, {
						x: xShift * currentStrength,
						y: yShift * currentStrength,
					});
				}
			}
		}
		
		return;
	}

	force.initialize = function () {
		// Nothing to do
	};

	force.links = function (_: Array<NCLink>) {
		links = _;
	};

	force.strength = function (_: number) {
		return arguments.length ? ((strength = +_), force) : strength;
	};

	return force;
}
